import React, {Component} from "react";
import {translate} from "../Services/translation";
import Svg from "./Svg";

class OrderHistoryFilter extends Component {
    constructor(props) {
        super(props);

        this.onInput = this.onInput.bind(this);

        const {
            searchPhrase,
            businessCustomer,
            approverRole,
            showOnlyMyOrders
        } = props;

        this.inputTimeoutRef = 0;
        this.businessCustomer = !!parseInt(businessCustomer);
        this.approverRole = !!parseInt(approverRole);
        this.showOnlyMyOrders = !!parseInt(showOnlyMyOrders);
        this.allowShowOnlyMyOrders = this.businessCustomer && this.approverRole;

        this.state = {
            searchPhrase: searchPhrase,
            showOnlyMyOrders: this.showOnlyMyOrders,
            timeout: 0,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.inputTimeoutRef) {
            clearTimeout(this.inputTimeoutRef);
        }

        this.inputTimeoutRef = setTimeout(() => this.autoSubmit(), this.state.timeout);
    }

    BuildRedirectQuery() {
        const params = new URLSearchParams();

        if (this.state.searchPhrase.trim() !== '') {
            params.append('searchPhrase', this.state.searchPhrase);
        }

        if (this.allowShowOnlyMyOrders && this.state.showOnlyMyOrders) {
            params.append('showMyOrders', 'True');
        }

        return params.toString();
    }

    autoSubmit() {
        let queryString = this.BuildRedirectQuery();
        let url = this.props.listUrl;

        if (queryString !== '') {
            url += `?${queryString}`;
        }

        window.location.href = url;
    }

    onInput(e) {
        this.setState({
            [e.target.name]: e.target.value,
            timeout: 1000,
        });
    }

    onCheckboxChange(e) {
        let checked = e.target.checked;

        this.setState({
            [e.target.name]: checked,
            timeout: 200,
        });
    }

    render() {
        return <>
            <div className="order-history-filter__container">
                <div className="order-history-filter__inner">
                    <label>
                        <input
                            type="checkbox"
                            name="showOnlyMyOrders"
                            checked={this.state.showOnlyMyOrders}
                            onChange={e => this.onCheckboxChange(e)}
                            className="form__radio"
                        ></input>
                        {translate("orderlist.filter.showonlymyorders")}
                    </label>
                </div>
            </div>

            <div className="order-history-filter__container">
                <div className="order-history-filter__inner">
                    <label>
                         <input
                             placeholder={translate('order.history.filter.freetext.placeholder')}
                             value={this.state.searchPhrase}
                             name="searchPhrase"
                             onInput={e => this.onInput(e)}
                             onChange={e => this.onInput(e)}
                             className="inputfield inputfield__textbox">
                         </input>
                    </label>

                    {this.state.searchPhrase !== '' &&
                        <Svg icon="cancel" extraClass="order-history-filter__clear" onClick={() => {this.setState({searchPhrase: '', timeout: 0})}}></Svg>}
                </div>
            </div>
        </>
    }
}

export default OrderHistoryFilter;

